import { useEffect } from "react";
import { MicroUserInfoProfile } from "@renderbus/widgets";
import styled from "styled-components";
import { useGlobalStore } from "@/store/GlobalStore";
import routerUtil from "@/utils/routerUtil";
import { getMemberLevelTranslate } from "@/pages/profile/helper/getMemberLevelTranslate";
import { getAuthStatusTranslate } from "@/pages/profile/helper/getAuthStatusTranslate";
import i18next from "i18next";
import { logoutHelper } from "@/utils/logoutHelper";
import { redirectToAuth } from "@/pages/profile/helper/redirectToAuth";
import { useVocherInfo } from "@/pages/profile/hooks/useVocherInfo";
import { toCoupon } from "@/pages/profile/components/profile-charge-card";
import { DataCollector } from "@rayvision/data-collect";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import { usePermissionStore } from "@/store/PermissionStore";

const microUserInfoProfile = new MicroUserInfoProfile("renderbus-user-profile");
export function UserProfile() {
  const {
    userInfo,
    currencySymbol,
    userBalance,
    userCredit,
    userCouponCount,
    userCouponPrice,
    isPictureUser,
    isDomestic,
    isCertified,
    isStudentValid,
    isSubAccount,
    userLevel,
    studentCertifyInfo,
    isPersonal,
    isHideBalance,
    userDesktopInfo,
    fetchUserDesktopInfo,
  } = useGlobalStore();
  const { userProperty } = useUserPropertyStore();
  const { vocherInfo, recentExpireDate } = useVocherInfo();
  const { checkNoPermission } = usePermissionStore();
  useEffect(() => {
    if (!userInfo) return;
    const topUpBasename =
      process.env.NODE_ENV === "development" ? "/topUp" : "/center/user/topUp";
    microUserInfoProfile.render({
      userInfo: {
        ...(userInfo || {}),
        ...(userDesktopInfo || {}),
        isHideBalance,
        isPictureUser,
        isDomestic,
        isSubAccount,
        userName: userInfo.userName,
        uuid: userInfo.fatherUuid,
        currencySymbol,
        userBalance,
        userCredit,
        userCouponCount,
        userCouponPrice,
        qyCoupon: userInfo.qyCoupon || 0,
        qyCouponCount: userInfo.qyCouponCount,
        vocherCount: vocherInfo ? vocherInfo.effectiveVoucher.length : 0,
        vocherExpireDate: recentExpireDate,
        userTotalCredit: userInfo?.totalCredit,
        memberLevelTranslate: getMemberLevelTranslate(
          isPictureUser ? userInfo.pictureLever : userLevel
        ),
        isCertified,
        authStatusTranslate: isDomestic
          ? `${getAuthStatusTranslate(
              userInfo.authStatus,
              isStudentValid,
              isPersonal
            )}`
          : "",
        userLevel,
        picMemberValidity: userInfo.picMemberValidity,
        isFirstRecharge: userProperty.isFirstRecharge,
      },
      language: i18next.language === "zh" ? "zh" : "en",
      toRecharge: (searchParams) => {
        DataCollector.emit("keypage_click", {
          header_button_type: "顶部导航栏",
          sub_button_type: "个人信息下拉",
          button_name: "充值按钮",
        });

        let url = topUpBasename;
        if (searchParams) {
          const normalizedParams = searchParams.startsWith("?")
            ? searchParams
            : `?${searchParams}`;
          url += normalizedParams;
        }

        window.open(url, "_blank");
      },
      toUserCenter: (to = "/") => {
        DataCollector.emit("keypage_click", {
          header_button_type: "顶部导航栏",
          sub_button_type: "个人信息下拉",
          button_name: "个人中心按钮",
        });
        routerUtil.navigate?.(to);
      },
      logout: () => {
        DataCollector.emit("keypage_click", {
          header_button_type: "顶部导航栏",
          sub_button_type: "个人信息下拉",
          button_name: "退出登录按钮",
        });
        logoutHelper();
      },
      toAuth: () => redirectToAuth(userInfo, studentCertifyInfo?.studentBlock),
      toCoupon: (key, path) => toCoupon(key, path),
      toPictureVip: () => {
        DataCollector.emit("keypage_click", {
          header_button_type: "顶部导航栏",
          sub_button_type: "个人信息下拉",
          button_name: "效果图用户开通会员按钮",
        });
      },
      checkNoPermission,
      onTabChange: (key) => {
        if (key === "desktop") {
          void fetchUserDesktopInfo();
        }
      },
    });
  }, [
    userInfo,
    currencySymbol,
    userBalance,
    userCredit,
    userCouponCount,
    userCouponPrice,
    isPictureUser,
    isDomestic,
    isCertified,
    vocherInfo,
    recentExpireDate,
    isSubAccount,
    userLevel,
    studentCertifyInfo,
    isStudentValid,
    isPersonal,
    isHideBalance,
    userProperty,
    checkNoPermission,
    userDesktopInfo,
    fetchUserDesktopInfo,
  ]);

  return <ProfileWrapper id="renderbus-user-profile" />;
}

const ProfileWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  right: 10;
  cursor: default !important;
`;
